@if (config && isInitialized) {
  <div id="collagedesigner3-content">
    <design-step></design-step>
  </div>
}
